<template>
  <div id="app ">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',

}
</script>

<style type="scss">
  @import "https://at.alicdn.com/t/font_338631_n5b5y1p4myc1h5mi.css";

</style>



// WEBPACK FOOTER //
// src/App.vue